import React from 'react';
import { useHistory } from 'react-router';
import en from '../../lang/en-us';
import { isMobileDevice } from '../../utils/constants';

const { footer } = en;

export default function Footer() {
    const history = useHistory();
    return (
        <footer>
            <div className="maxWidth">
                <p className="copyright">{footer.copyRightText}</p>
                <ul>
                    <li>
                        <a
                            href={isMobileDevice() ? '/links/terms-of-use' : '/links/terms-of-use'}
                            target={isMobileDevice() ? '_self' : '_blank'}
                            rel="noopener noreferrer"
                            role="link"
                            tabIndex={0}
                            aria-label="Terms of Use - Opens in new tab"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    if (isMobileDevice()) {
                                        history.push('/links/terms-of-use');
                                    } else {
                                        window.open('/links/terms-of-use', '_blank');
                                    }
                                }
                            }}
                        >
                            {footer.actions.termsOfUse.title}
                        </a>
                    </li>
                    <li>
                        <a
                            href={isMobileDevice() ? '/links/privacy-policy' : '/links/privacy-policy'}
                            target={isMobileDevice() ? '_self' : '_blank'}
                            rel="noopener noreferrer"
                            role="link"
                            tabIndex={0}
                            aria-label="Privacy Policy - Opens in new tab"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    if (isMobileDevice()) {
                                        history.push('/links/privacy-policy');
                                    } else {
                                        window.open('/links/privacy-policy', '_blank');
                                    }
                                }
                            }}
                        >
                            {footer.actions.privacy.title}
                        </a>
                    </li>
                    {/* <li>
                        <a href="#">{footer.actions.termsOfBusiness.title}</a>
                    </li> */}
                </ul>
            </div>
        </footer>
    );
}
